import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Hourglass, XCircle, RefreshCw } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { Chat } from "@/components/members/Chat";
import { AuraMark } from "@/components/site/AuraMark";

const StatusScreen = ({ user, t, refresh }) => {
  const rejected = user.status === "rejected";
  const Icon = rejected ? XCircle : Hourglass;
  return (
    <div className="glass w-full max-w-lg rounded-[2rem] p-8 md:p-10" data-testid="member-status-screen">
      <span className={`grid place-items-center w-14 h-14 rounded-2xl ${rejected ? "bg-rose-500/15 text-rose-300" : "bg-violet-500/15 text-violet-300"}`}>
        <Icon className={`w-7 h-7 ${rejected ? "" : "animate-[spin_4s_linear_infinite]"}`} />
      </span>
      <h1 className="mt-6 font-display text-3xl font-extrabold text-white">{rejected ? t.pending.rejectedTitle : t.pending.title}</h1>
      <p className="mt-4 text-slate-300 leading-relaxed">{rejected ? t.pending.rejectedDesc : t.pending.desc}</p>
      <div className="mt-6 flex items-center gap-3 rounded-2xl border border-white/10 p-4">
        {user.picture ? <img src={user.picture} alt="" className="w-10 h-10 rounded-full" referrerPolicy="no-referrer" /> : <AuraMark className="w-10 h-10" />}
        <div className="min-w-0">
          <p className="text-white font-semibold truncate">{user.name}</p>
          <p className="text-sm text-slate-400 truncate">{user.email}</p>
        </div>
      </div>
      {!rejected && (
        <button onClick={refresh} data-testid="pending-refresh-button" className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm text-white hover:bg-white/10 transition-colors">
          <RefreshCw className="w-4 h-4" /> {t.pending.refresh}
        </button>
      )}
    </div>
  );
};

export default function Members() {
  const { t } = useLang();
  const { user, refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === false) navigate("/accedi", { replace: true });
  }, [user, navigate]);

  if (!user) return <div className="min-h-screen grid place-items-center"><AuraMark className="w-12 h-12 animate-pulse" /></div>;

  return (
    <main className="min-h-screen pt-[88px] pb-6 px-3 md:px-8 flex justify-center items-start" data-testid="members-page">
      {user.status === "approved" ? <Chat user={user} /> : <div className="pt-10 w-full flex justify-center"><StatusScreen user={user} t={t} refresh={refresh} /></div>}
    </main>
  );
}
